<div class="card-structure">
  <app-carousel [items]="data" (current)="onChange($event)">
    <ng-template let-slide>
      <div class="card-structure__image">
        <img loading="lazy" class="w-full" [src]="slide.imagem_desktop" [alt]="slide.titulo" />
      </div>
    </ng-template>
  </app-carousel>

  <div class="card-structure__group" *ngIf="current$ | async as current">
    <div class="card-structure__info">
      <p>{{ current.titulo }}</p>
      <span> {{ current.chamada }}</span>
    </div>
  </div>
  <div
    class="bg-no-repeat bg-cover card-structure__title bg-base-bluebg-center"
    style="background-image: url('assets/images/textura.webp')"
  >
    <img [src]="title$ | async" />
  </div>
</div>
